/**
 * 基础信息
 */

import { useState, useEffect } from 'react';
import {
    Divider,
    theme,
    Tag,
    ColorPicker,
    Space,
    Button,
    Radio,
    message,
    Badge,
    Select,
    Typography,
    Flex,
    Tooltip,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config.js';

const { Text, Title, Paragraph } = Typography;

const BasicInfo = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [basicinfo, setBasicinfo] = useState({});

    const {
        token: { colorPrimary },
    } = theme.useToken();

    const [themeColor, setThemeColor] = useState(colorPrimary);
    const [isDisplayTableBorder, setIsDisplayTablesBorder] = useState(0);
    const [jumpUrl, setJumpUrl] = useState('');

    useEffect(() => {
        // 初始化账户基础信息
        $.ajax({
            url: `${CNF.api}users/basicinfo`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    setBasicinfo(data.dat);
                    setIsDisplayTablesBorder(data.dat.is_display_table_border || 0);
                    setJumpUrl(data.dat.jump_url || '');
                }
            }
        });
    }, []);

    const save = () => {
        // 保存基础设置信息
        $.ajax({
            url: `${CNF.api}users/basicinfo`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                theme_color: themeColor,
                is_display_table_border: isDisplayTableBorder,
                jump_url: jumpUrl,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    return (
        <div style={{ height: '100%', padding: '0 30px' }}>
            {contextHolder}
            <Title level={5}>{props.m > 0 ? CNF.navUserItems[props.m - 1].name : ''}</Title>
            <Divider style={{ borderColor: colorPrimary }} />
            <Flex vertical gap='medium'>
                {/* 基本信息 */}
                <Space><Text>组织：</Text><Text>{basicinfo.org_info_name}</Text></Space>
                <Space><Text>部门：</Text><Text>{basicinfo.department}</Text></Space>
                <Space><Text>岗位：</Text><Text>{basicinfo.job}</Text></Space>
                <Space><Text>性别：</Text><Text><Tag color={colorPrimary}>{basicinfo.sex}</Tag></Text></Space>
                <Space><Text>出生日期：</Text><Text>{basicinfo.birth_date}</Text></Space>
                <Space><Text>能力类型：</Text><Text>{basicinfo.ability_type}</Text></Space>
                <Space><Text>教育背景：</Text><Text>{basicinfo.edu_background}</Text></Space>
                <Space><Text>家庭住址：</Text><Text>{basicinfo.address}</Text></Space>
                <Space><Text>入职日期：</Text><Text>{basicinfo.entry_date}</Text></Space>
                <Space><Text>身份证号：</Text><Text>{basicinfo.idcard}</Text></Space>

                {/* 主题设置 */}
                <Space>
                    <Text>主题设置：</Text>
                    <ColorPicker
                        disabledAlpha
                        presets={[{ label: '推荐主题', colors: CNF.themeColors, key: '推荐主题' }]}
                        defaultValue={colorPrimary}
                        onChange={(value) => {
                            setThemeColor(value.toHexString());
                            props.setThemeColor(value.toHexString());
                        }}
                    />
                </Space>

                {/* 表格边框 */}
                <Space>
                    <Tooltip title='表格列表是否显示边框'><Text>表格边框：</Text></Tooltip>
                    <Radio.Group
                        value={isDisplayTableBorder}
                        options={[
                            { value: 0, label: '否' },
                            { value: 1, label: '是' },
                        ]}
                        onChange={(e) => setIsDisplayTablesBorder(e.target.value)}
                    />
                </Space>

                {/* 表格边框 */}
                <Space>
                    <Tooltip title='登录后跳转路径'><Text>跳转路径：</Text></Tooltip>
                    <Select
                        size='small'
                        placeholder='请选择'
                        style={{ width: 90 }}
                        options={props.navLists && props.navLists.map(item => {
                            return {
                                value: item.url,
                                label: item.name
                            }
                        })}
                        value={jumpUrl || undefined}
                        onChange={(value) => setJumpUrl(value)}
                    />
                </Space>

                <Paragraph><Button color='primary' variant='solid' onClick={() => save()}>保存</Button></Paragraph>
                <Paragraph style={{ fontSize: 11 }}><Badge color={colorPrimary} status='processing' size='small' /> 备注: 保存后重新登录使配置生效</Paragraph>
            </Flex>
        </div>
    );
}

export default BasicInfo